export default function () {
  const $hiddenElement = $('.js-hidden');
  if ($hiddenElement.length) {
    setTimeout(() => {
      $hiddenElement.removeClass('js-hidden');
    }, 500);
  }

  const $radios = $('input[type="radio"][data-toggle="collapse"]');

  if ($radios.length) {
    $radios.each((index, element) => {
      const $radio = $(element);
      const $radioGroup = $(`[name="${$radio.attr('name')}"]`);
      const $collapseTarget = $($radio.data('target'));

      __toggleRadioTarget($radio, $collapseTarget);

      // Toggle on change
      $radioGroup.on('change', (event) => {
        const $changedRadio = $(event.delegateTarget);
        const $collapseTarget = $($radio.data('target'));
        const hasCollapseTarget = $changedRadio.data('target') !== undefined;

        // Disable radio: prevent multiple parallel runs
        if (hasCollapseTarget) {
          $changedRadio.prop('disabled', true);
        }

        __toggleRadioTarget($radio, $collapseTarget);

        // Re-enable checkbox
        if ($changedRadio.prop('disabled') === true) {
          $collapseTarget.on('shown.bs.collapse hidden.bs.collapse', () => {
            $changedRadio.prop('disabled', false);
          });
        }
      });
    });

    /**
     * @param {array} $radio
     * @param {array} $collapseTarget
     */
    function __toggleRadioTarget($radio, $collapseTarget) {
      // Important: init collapsible beforehand
      $collapseTarget.collapse({
        toggle: false,
      });

      if ($radio.prop('checked') === true) {
        $collapseTarget.on('show.bs.collapse', function (e) {
          e.stopPropagation();
        });
        $collapseTarget.collapse('show');
        $radio.attr('data-toggle', null);
      } else {
        $collapseTarget.on('hide.bs.collapse', function (e) {
          e.stopPropagation();
        });
        $collapseTarget.collapse('hide');
        $radio.attr('data-toggle', 'collapse');
      }
    }
  }
}
